module.exports = __webpack_public_path__ + "img/188857.f1527ebc.svg";